module.exports = __webpack_public_path__ + "static/engcomp-logo-a259a9c79dade076115b2a6949532052.png";